import { loadTimeForm } from 'features/daily-plan/utils';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { EntityType } from 'UI/constants/entityTypes';
import { nestTernary } from 'UI/utils';
import { OptionRenderers, Selectors } from 'UI/utils/renderers';

import { prepareDateForPicker } from '../shared/DateTimePickers/DateTimePicker.utils';

export const FORM_FIELDS_MAP = {
  TaskId: {
    key: 'id'
  },
  TaskType: {
    key: 'taskType',
    paramKey: 'taskTypeId',
    outboundAccesor: 'id'
  },
  Date: {
    key: 'date',
    inboundAccesor: form => prepareDateForPicker(form)
  },
  Time: {
    key: 'time',
    inboundAccesor: loadTimeForm
  },
  CandidateToMarket: {
    key: 'candidateToMarket',
    paramKey: 'candidateOfferId',
    outboundAccesor: 'id',
    inboundAccesor: form => ({
      id: form.candidate?.id,
      title: form.candidate?.personalInformation?.fullName
    })
  },
  ReachToEntity: {
    key: 'reachTo',
    inboundAccesor: form =>
      form.entityType?.code === EntityType.Contact ||
      form.entityType?.code === EntityType.HiringAuthority
        ? EntityType.HiringAuthority
        : nestTernary(form.entityType?.code === EntityType.Company, EntityType.Company, null)
  },
  ReachToName: {
    key: 'reachToName',
    outboundAccesor: 'id',
    inboundAccesor: form => {
      const key =
        form.entityType?.code === EntityType.Contact ||
        form.entityType?.code === EntityType.HiringAuthority
          ? 'fullName'
          : 'name';
      const entityKey = form.entityType?.code === EntityType.Company ? 'type' : 'entityType';
      return {
        id: form.entity?.id,
        [key]: form?.entity?.contactName,
        [entityKey]: form.entityType?.code
      };
    }
  },
  Comments: {
    key: 'comment',
    inboundAccesor: 'lastComment'
  }
};

export const REACH_OUT_AUTOCOMPLETE_PROPS_BY_ENTITY = {
  company: {
    displayKey: 'name',
    placeholder: strings.dailyPlan.drawer.form.placeholders.selectCompany,
    url: Endpoints.Search,
    typeaheadParams: { entityType: EntityType.Company },
    getOptionSelected: Selectors.byId,
    renderOption: OptionRenderers.globalSearchDefault('name'),
    typeaheadLimit: 50
  },
  hiringAuthority: {
    placeholder: strings.dailyPlan.drawer.form.placeholders.selectContact,
    url: Endpoints.Search,
    typeaheadParams: { schema: 'contactDirectory', entityTypeGroup: EntityType.HiringAuthority },
    getOptionSelected: Selectors.byId,
    renderOption: OptionRenderers.globalSearchPerson('fullName'),
    displayKey: 'fullName',
    typeaheadLimit: 20
  }
};

export const REACH_OUT_TO_RADIO_OPTIONS = [
  {
    id: 1,
    value: 'hiringAuthority',
    label: `${strings.dailyPlan.drawer.form.labels.hiringAuthority} / ${strings.dailyPlan.drawer.form.labels.hiringAuthorityProspect}`
  },
  {
    id: 2,
    value: 'company',
    label: strings.dailyPlan.drawer.form.labels.company
  }
];
